import { BannerProvider } from "./../../../../../node_modules/@playcharge/common/models/backend/banners/banner-provider";
import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatChipInputEvent, MatChipsModule } from "@angular/material/chips";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatOption, MatSelect } from "@angular/material/select";
import { EnumKeyValuePipe } from "../../../pipes/enumKeyValue.pipe";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BannerBackOfficeViewModel } from "@playcharge/common/models/backend/banners/backoffice/banner-backoffice-view-model";
import { BannerEditModel } from "@playcharge/common/models/backend/banners/backoffice/banner-edit-model";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { MatCheckbox } from "@angular/material/checkbox";

@Component({
    selector: "app-edit-banner-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
        MatIcon,
        EnumKeyValuePipe,
        MatCheckbox,
        MatButton,
    ],
    templateUrl: "./edit-banner-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditBannerDialogComponent implements OnInit {
    private _selfRef: MatDialogRef<EditBannerDialogComponent, BannerEditModel> = inject(
        MatDialogRef<EditBannerDialogComponent, BannerEditModel>,
    );

    private _data: Nullable<BannerBackOfficeViewModel> = inject(MAT_DIALOG_DATA);

    public form = new FormGroup({
        id: new FormControl<number>(0, { nonNullable: true }),
        provider: new FormControl<BannerProvider>(BannerProvider.None, { nonNullable: true }),
        allowedCountries: new FormControl<string[]>([], { nonNullable: true }),
        isActive: new FormControl<boolean>(false, { nonNullable: true }),
    });

    public BannerProvider = BannerProvider;

    public ngOnInit(): void {
        if (this._data) {
            this.form.patchValue({
                id: this._data.id,
                provider: this._data.provider,
                allowedCountries: this._data.allowedCountries ?? [],
                isActive: this._data.isActive,
            });
        }
    }

    public get allowedCountriesControl(): FormControl<string[]> {
        return this.form.controls.allowedCountries;
    }

    public addCountry(event: MatChipInputEvent): void {
        const value = event.value.trim();

        if (!value) {
            return;
        }

        if (this.allowedCountriesControl.value) {
            this.allowedCountriesControl.patchValue([...this.allowedCountriesControl.value, value]);
        } else {
            this.allowedCountriesControl.patchValue([value]);
        }

        event.chipInput.clear();
    }

    public removeCountry(country: string): void {
        if (this.allowedCountriesControl.value) {
            const index = this.allowedCountriesControl.value.indexOf(country);

            if (index >= 0) {
                this.allowedCountriesControl.patchValue([
                    ...this.allowedCountriesControl.value.slice(0, index),
                    ...this.allowedCountriesControl.value.slice(index + 1),
                ]);
            }
        }
    }

    public close(): void {
        this._selfRef.close(this.form.getRawValue());
    }
}
